import { number, oneOfType, string, func, arrayOf, shape } from "prop-types";
import CircleInfoSolidV6 from "@shared/v2/Icomoon/Icons/CircleInfoSolidV6";
import Dropdown from "@shared/v2/Dropdown";
import Tooltip from "@shared/v2/Tooltip";
import ResultsBanner from "./ResultsBanner";

const UpdateFrequency = ({
  validReportCount,
  selectedLeads,
  handleDripFrequencyChange,
  dripFrequency,
  selectedDripFrequency,
}) => (
  <div>
    <ResultsBanner totalLeads={selectedLeads.length} count={validReportCount} />

    <div className="tw-grid tw-grid-cols-2 tw-gap-[24px]">
      <div className="tw-mb-[15px]">
        <Dropdown
          label={
            <>
              Market Report Drip Frequency
              <Tooltip
                trigger={<CircleInfoSolidV6 size="m" className="tw-text-gray-75 tw-ml-[4px]" />}
                innerClassName="!tw-text-left tw-max-w-[250px]"
                content="How often the dynamic Market Report will be emailed to the contacts"
                placement="top"
              />
            </>
          }
          isClearable={false}
          name="dripFrequency"
          onChange={handleDripFrequencyChange}
          options={dripFrequency}
          placeholder="Drip Frequency"
          value={dripFrequency.find((d) => d.value === selectedDripFrequency)}
        />
      </div>

      <div></div>
    </div>
  </div>
);

const optionsPropTypes = arrayOf(shape({ label: string, value: string }));

UpdateFrequency.propTypes = {
  validReportCount: number,
  selectedLeads: arrayOf(oneOfType([number, string])),
  handleDripFrequencyChange: func,
  dripFrequency: optionsPropTypes,
  selectedDripFrequency: string,
};

UpdateFrequency.defaultProps = {
  validReportCount: 0,
  selectedLeads: [],
  handleDripFrequencyChange: null,
  dripFrequency: [],
  selectedDripFrequency: "every_2_weeks",
};

export default UpdateFrequency;
